export default __webpack_public_path__ + "static/media/sprinkler-center.97e04087.png";